import { SxProps } from '@mui/material';
import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';

const container: SxProps = {
  flex: 1,
  display: 'flex',
  width: '100%',
  minHeight: '90vh',
  flexDirection: 'column',
  height: '100%',
  paddingBottom: GLOBAL_MARGIN_HORIZONTAL * 2,
};

const listItem: SxProps = {
  paddingLeft: 0,
  paddingRight: GLOBAL_MARGIN_HORIZONTAL,
};

const contentContainer: SxProps = {
  marginTop: { xs: 8, sm: 8 },
};

const titleRow: SxProps = {
  display: 'flex',
  alignItems: 'center',
  columnGap: 1,
};

const logoFrame: SxProps = {
  width: 96,
  height: 96,
  borderRadius: 2,
  border: '1px dashed #cbd5e1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  backgroundColor: '#f8fafc',
};

const qrCanvas: SxProps = {
  width: { xs: 220, sm: 280, md: 300 },
  height: { xs: 220, sm: 280, md: 300 },
  display: 'flex',
};

const sectionCard: SxProps = {
  padding: { xs: 2.5, sm: 3 },
  borderRadius: 2,
  border: '1px solid #e2e8f0',
  backgroundColor: '#fff',
  boxShadow: '0 8px 30px rgba(15,23,42,0.04)',
};

const sectionStack: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

const reviewLandingField: SxProps = {
  width: 320,
};

const logoPlaceholderText: SxProps = {
  textAlign: 'center',
  px: 1,
};

const captionTight: SxProps = {
  mt: 0.5,
};

const twoColRow: SxProps = {
  flexDirection: { xs: 'column', sm: 'row' },
  gap: 2,
};

export {
  container,
  listItem,
  contentContainer,
  titleRow,
  qrCanvas,
  sectionCard,
  sectionStack,
  logoFrame,
  reviewLandingField,
  logoPlaceholderText,
  captionTight,
  twoColRow,
};
